<template>
  <div v-html="markdownToHtml"/>
</template>
<script>
import showdown from "showdown";
export default {
  name: "VShowdown",
  props: {
    source: {
      type: String
    }
  },
  computed: {
    markdownToHtml() {
      const converter = new showdown.Converter({
        openLinksInNewWindow: true,
        tables: true
      });
      return converter.makeHtml(this.source);
    }
  }
};
</script>

<style scoped>
</style>
